<script setup lang="ts">
// Loading placeholder for the lazily-loaded MapLocation component (BC-40).
// Mirrors the MapLocation container dimensions so the map chunk can load after
// first paint without any layout shift.
</script>

<template>
    <div class="relative h-full">
        <div class="sticky top-32 w-full h-[50vh] lg:h-[80vh] bg-neutral-100"></div>
    </div>
</template>
